import React, { useState } from "react";
import { useTheme } from "../context/ThemeContext";

function InitialDeposit({ initialDeposit, setInitialDeposit }) {
  const [tempDeposit, setTempDeposit] = useState("");
  const { darkMode } = useTheme();

  const handleBeginBacktest = () => {
    if (tempDeposit && parseFloat(tempDeposit) > 0) {
      setInitialDeposit(parseFloat(tempDeposit));
    } else {
      alert("Please enter a valid initial deposit amount greater than 0");
    }
  };

  return (
    <div
      className={`max-w-md mx-auto ${
        darkMode ? "bg-gray-800" : "bg-white"
      } p-8 rounded-lg shadow-md`}
    >
      <h2
        className={`text-2xl font-bold ${
          darkMode ? "text-white" : "text-gray-800"
        } mb-6 text-center`}
      >
        Welcome to Trading Journal
      </h2>
      <div className="space-y-6">
        <div>
          <label
            className={`block text-sm font-medium ${
              darkMode ? "text-gray-200" : "text-gray-700"
            } mb-2`}
          >
            Enter Your Initial Deposit
          </label>
          <div className="relative">
            <span
              className={`absolute left-3 top-1/2 transform -translate-y-1/2 ${
                darkMode ? "text-gray-400" : "text-gray-500"
              }`}
            >
              $
            </span>
            <input
              type="number"
              value={tempDeposit}
              onChange={(e) => setTempDeposit(e.target.value)}
              className={`border p-2 rounded w-full pl-8 text-lg ${
                darkMode
                  ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                  : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
              }`}
              placeholder="0.00"
              min="0"
              step="0.01"
            />
          </div>
        </div>
        <button
          onClick={handleBeginBacktest}
          className={`w-full ${
            darkMode
              ? "bg-blue-600 hover:bg-blue-700"
              : "bg-blue-500 hover:bg-blue-600"
          } text-white px-4 py-3 rounded-lg transition-colors duration-150 font-medium text-lg`}
        >
          Begin Backtest
        </button>
        <p
          className={`text-sm ${
            darkMode ? "text-gray-400" : "text-gray-500"
          } text-center`}
        >
          Enter your initial deposit amount to start tracking your trades
        </p>
      </div>
    </div>
  );
}

export default InitialDeposit;
